import React, { Fragment } from 'react';
import { get } from 'lodash';
import './index.scss';
const HeaderImages = props => {
	let albumList = props.albumList;
	console.log('albumList00000000000000000');
	console.log(albumList);
	function handleClick(index, isVideo) {
		props.onClick(index, isVideo);
	}
	function isVideo(url) {
		let extensions = ['mp4', 'MP4', 'MOV', 'mov'];
		let extension = url.slice(url.lastIndexOf('.') + 1);
		return extensions.includes(extension);
	}
	return (
		<ul className="images clearfix">
			{get(albumList, 'topicContents', '') &&
				albumList.topicContents.map((item, index) => {
					return (
						<li key={'img-topic-item' + index}>
							{item.type === 2 ? (
								<Fragment>
									<img data-src={item.thumbKey} alt="" className="lazy" />
									<i
										className="play-button"
										onClick={() => {
											handleClick(index, true);
										}}>
										<span className="iconfont">&#xe66a;</span>
									</i>
								</Fragment>
							) : (
								<img
									alt=""
									className="lazy"
									data-src={item.thumbKey || item.key}
									onClick={() => {
										handleClick(index);
									}}
								/>
							)}
						</li>
					);
				})}
		</ul>
	);
};
export { HeaderImages };
